<template>
  <div class="DetailU">
    <div class="content-info">
      <div class>
        <p class="o-b t-i">Reservaciones</p>
        <div class="c-i-c">
          <p class="o-b t-u-c">Reservaciones: {{totalAppointment}}</p>
        </div>
        <div class="b-c">
          <div class="form-search-m">

              <p class="o-b inline">Estilista:</p>
              
              <select class="select-css" v-model="stylistSelected" name="stylist">>
                <option selected value="" >-- Selecciona una opción -- </option>
                <option selected value="init" > Mostrar todo </option>
                <option v-for="data in userStylelist" :key="data.id" :value="data.id">{{data.fullname}}</option>
              </select>
              
            <button v-on:click="searchInfo" class="o-b but-g" id="basic-addon1">Buscar</button>
            <button
              v-if="showCalendar"
              v-on:click="mostrarLista"
              class="o-b btn-f but-b"
              id="basic-addon1"
            >Ver como lista</button>
            <button
              v-if="showList"
              v-on:click="mostrarCalendario"
              class="o-b btn-f but-b"
              id="basic-addon1"
            >Ver como calendario</button>
          </div>
          <p class="error" v-if="errors != ''">
                <ul>
                  <li>{{ errors }}</li>
                </ul>
              </p>
        </div>
      </div>


      <div class="b-c">
        <div style="margin-bottom: 100px;" v-if="showList">

          <div class="text-center c-c-btns">
            <p v-on:click="filterTableStatus(0)" class="div-btn-c confirm">Por asignar</p>
            <p v-on:click="filterTableStatus(1)" class="div-btn-c assign">Asignado</p>
            <p v-on:click="filterTableStatus(2)" class="div-btn-c final">Concluido</p>
            <p v-on:click="filterTableStatus(3)" class="div-btn-c cancel">Cancelado</p>
            <p v-on:click="all" class="div-btn-c all">Mostrar todo</p>
            
          </div>
          
          <p class="o-b sub-t">Reservaciones</p>

          <div class="f-r">
            <p class="o-b sub-t">Ordenar por: </p>
              <select class="select-css" v-model="filterText" v-on:change="filter" name="nombre"> 
                <option value selected="selected">Selecciona una opción</option>
                <option value="date">Fecha</option>
                <option value="dateAsc">Fecha mas reciente</option>
                <option value="finalAmount">Monto de pago</option>
              </select> 
            </div>
          <div class="list">
            <div v-bind:class="{'c-t-info-h-active': activeUR}" class="c-t-info">
              <table style="table-layout: auto; width: 100%" class="table table-light m-top">
                <thead>
                  <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Horario</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Servicio</th>
                    <th scope="col">Categoría</th>
                    <th scope="col">Estilista</th>
                    <th scope="col">Pago</th>
                    <th scope="col">Promocode</th>
                    <th scope="col">Comentarios</th>
                    <th scope="col">Rating de servicio</th>
                    <th scope="col">Rating de Estilista</th>
                    <th scope="col">Estatus</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-bind:class="{'bgRed' : typeof data.cancelDate !== 'undefined'}" v-for="data in appointmentObject" :key="data.id">
                    <td>{{data.date}}</td>
                    <td>{{data.hour}}</td>
                    <td><p>{{data.client}}</p></td>
                    <td>{{data.service.name}}</td>
                    <td v-if="typeof data.service.category === 'undefined' "> - </td> <td v-else> {{data.service.category.name}} </td>
                    <td v-if="typeof data.professional === 'undefined' "> - </td> <td v-else> {{data.professional.fullname}} </td>
                    <td>${{data.finalAmount}}</td> 
                    <td v-if="data.data.promocode"> {{data.data.promocode.code}} </td> <td v-else> - </td> 
                    <td><button v-on:click="comentario(data.comment)" class="btn-actions"><img src="@/assets/images/acciones.png" alt="acciones" /></button></td>
                    <td v-if="typeof data.rating === 'undefined' "> - </td><td v-else> {{data.rating}}/5 </td>
                    <td v-if="typeof data.ratingProfessional === 'undefined' "> - </td><td v-else> {{data.ratingProfessional}}/5 </td>
                    <td class="tabll-c"> <div style="width: 100px;"><p style="display: initial;">{{data.statusDescription}}</p><span v-bind:style="{ background: data.statusDescriptionColor }" class="indicator"></span></div></td>
                    <td>
                      <router-link :to="{name: 'DetailR', params:{id: data.id} }">
                        <button class="btn-actions">
                          <img src="@/assets/images/acciones.png" alt="acciones" />
                        </button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div style="padding-bottom: 20px" v-if="showCalendar" class="calendar">
          <div class="text-center c-c-btns">
            <p class="div-btn-c confirm">Por asignar</p>
            <p class="div-btn-c assign">Asignado</p>
            <p class="div-btn-c final">Concluido</p>
            <p class="div-btn-c cancel">Cancelado</p>
          </div>
          
          
          <FullCalendar id="calendar" :options="calendarOptions" />
        
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../parse/models/User'
import Appointment from "../parse/models/Appointment";
import Service from '../parse/models/Service'
import Category from '../parse/models/Category'

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";

export default {
  name: "DetailU",
  components: {
    FullCalendar,
  },
  data() {
    return {
      promocode: '-',
      errors: '',
      stylistSelected: "",
      userStylelist: [],
      showList: true,
      showCalendar: false,
      totalAppointment: 0,
      activeUR: true,
      appointmentObject: {},
      filterText: "",
      calendarOptions: {

        displayEventTime: false,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        eventClick: this.handleDateClick,
        initialView: "timeGridWeek",
        locale: "es",
        headerToolbar: {
          left: "",
          center: "prev,title,next",
          right: "dayGridMonth timeGridWeek timeGridDay",
          backgroundColor: '#fff'
        },
        events: [],
        buttonText: {
          today: "Hoy",
          month: "Mes",
          week: "Semana",
          day: "Dia",
          list: "Lista",
        },
        
        timeZone: "America/Mexico_City",
        height: 500,
        allDaySlot: false,
        slotMinTime: '08:00',
        slotMaxTime: '24:00',
      },
    };
  },

  beforeMount() {
    var f = 0;

    Appointment.load().then((points) => {
      
      this.appointmentObject = points;

      console.log(points)
      
      for (let i = 0, p = points; i < points.length; i++) {
    
        let hoy = this.moment(points[i].dateCalendar);
        const dateDay = hoy.format('YYYY-MM-DD');
        const starHour = hoy.format('HH:mm:ss');
        const mediahora = "00:" + points[i].service.maxDuration;
        
        hoy.add(this.moment.duration(mediahora));
        const endHour = hoy.format('HH:mm:ss')
        let end = this.moment(dateDay + " " + endHour).format('YYYY-MM-DD HH:mm:ss')

        this.calendarOptions.events.push({
          id: points[i].id,
          title: `${points[i].service.name}`,
          advancedTitle: 'second description',
          start: points[i].dateCalendar,
          end: end,
          allDay: false,
          color: points[i].statusDescriptionColor,
          resourceIds: ['a', 'b'],

          
        });
      }
    });
    
    Appointment.count().then((count) => {
      this.totalAppointment = count;
    });

    User.loadStylelist().then((user) => {
      this.userStylelist = user
    })

    Service.load().then((serv) => {
      console.log(serv)
    })

    Category.load().then((cat) => {
      console.log(cat)
    })


  },
  methods: {

    searchInfo(){
      
      this.calendarOptions.events = []
      const stylist  = this.stylistSelected
      
      if (stylist == "") {
        this.errors = 'Selecciona una opción'
        return;
      }else if (stylist == "init"){
        var f = 0;

        Appointment.load().then((points) => {
          
          this.appointmentObject = points;

          console.log(points)
          
          for (let i = 0, p = points; i < points.length; i++) {
        
            let hoy = this.moment(points[i].dateCalendar);
            const dateDay = hoy.format('YYYY-MM-DD');
            const starHour = hoy.format('HH:mm:ss');
            const mediahora = "00:" + points[i].service.maxDuration;
            
            hoy.add(this.moment.duration(mediahora));
            const endHour = hoy.format('HH:mm:ss')
            let end = this.moment(dateDay + " " + endHour).format('YYYY-MM-DD HH:mm:ss')

            this.calendarOptions.events.push({
              id: points[i].id,
              title: `${points[i].service.name}`,
              advancedTitle: 'second description',
              start: points[i].dateCalendar,
              end: end,
              allDay: false,
              color: points[i].statusDescriptionColor,
              resourceIds: ['a', 'b'],

              
            });
          }
        });
        
        Appointment.count().then((count) => {
          this.totalAppointment = count;
        });

        User.loadStylelist().then((user) => {
          this.userStylelist = user
        })
      } else {
        Appointment.loadReportWithPametersStylist(stylist)
        .then((points) => {
          this.appointmentObject = points;
          for (let i = 0, p = points; i < points.length; i++) {
            this.calendarOptions.events.push({
              title: points[i].service.name,
              start: points[i].dateCalendar,
              allDay: false,
              color: points[i].statusDescriptionColor,
            });
          }
        })
        .catch((error) => console.log(error));
        this.errors = ''
        console.log(this.calendarOptions.events)
      }
    },

    mostrarLista() {
      this.showCalendar = false;
      this.showList = true;
    },

    mostrarCalendario() {
      this.showList = false;
      this.showCalendar = true;
    },

    handleDateClick: function (arg) {
      //console.log(arg.event.id)
      this.$router.push({ name: 'DetailR', params:{id: arg.event.id} }); 
    },
    all(id){
      
      var f = 0;
      Appointment.load().then((points) => { 

      this.appointmentObject = points;
        console.log(points)
        for (let i = 0, p = points; i < points.length; i++) {
      
          let hoy = this.moment(points[i].dateCalendar);
          const dateDay = hoy.format('YYYY-MM-DD');
          const starHour = hoy.format('HH:mm:ss');
          const mediahora = "00:" + points[i].service.maxDuration;
          
          hoy.add(this.moment.duration(mediahora));
          const endHour = hoy.format('HH:mm:ss')
          let end = this.moment(dateDay + " " + endHour).format('YYYY-MM-DD HH:mm:ss')

          this.calendarOptions.events.push({
            id: points[i].id,
            title: `${points[i].service.name}`,
            advancedTitle: 'second description',
            start: points[i].dateCalendar,
            end: end,
            allDay: false,
            color: points[i].statusDescriptionColor,
            resourceIds: ['a', 'b'],

            
          });
        }
      });
    },

    filterTableStatus(id){
      Appointment.loadfilterTable(id).then((points) => {
        this.appointmentObject = points;
      });
    },

    filter() {
      Appointment.filter(this.filterText).then((points) => {
        this.appointmentObject = points;
      });
    },

    comentario(comment){
      this.$swal({
        title: 'Comentario',
        text: comment,
        showCloseButton: false,
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.tabll-c{
  display: table-cell;
  padding: .75em 0;
}

.indicator{
  width: 10px;
  height: 10px;
  border-radius: 20px;
  float: right;
  margin-top: 6px;
}

.inline {
  display: inline;
}

.div-btn-c {
  font-size: 11px;
  color: #fff;
  display: inline;
  margin: 5px;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.c-c-btns {
  margin-bottom: 1.5em;
}
.confirm {
  background: #28a745;
}
.assign {
  background: #ffc107;
}
.request {
  background: #007bff;
}
.final {
  background: #007bff;
}
.cancel {
  background: #ee7979;
}
.all {
  background: #3f3f3f;
}
/* Init detail*/
.btn-actions {
  background: #f6f6f6;
  border: none;
}

.bgRed{
  background: #ee7979;
  color: #fff;
}

.select-css {
  font-size: 15px;
  font-weight: 400;
  color: #444;
  line-height: 1.3;
  padding: 0.4em 1.4em 0.3em 0.8em;
  width: 230px;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.03);
  border-radius: 0.3em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #f3f3f3;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #f3f3f3 0%, #f3f3f3 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}

.c-t-info {
  width: 100%;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.c-t-info-h-active {

}

/* USER INFO */
.img_user {
  width: 138px;
  height: 138px;
  border-radius: 70px;
  float: left;
  margin-right: 20px;
}

.info-u {
  display: inline;
}

.info-ac button {
  display: inline;
}

table tbody tr {
  background: #f3f3f3;
}

.but-r {
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-r:hover {
  background: rgb(231, 76, 84);
}

.but-c {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 270px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-c:hover {
  background: #14fc78;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 300px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-right: 50px;
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
}

.sub-t {
  font-size: 18px;
  display: inline;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 2px;
  height: 40px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  margin: 0 0 0 20px;
}
.but-g:hover {
  background: #14fc78;
}

.but-b {
  background: #000;
  color: #fff;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 10px;
}
.but-b:hover {
  background: rgb(27, 27, 27);
}

.btn-f {
  margin: 0 40px 0 20px;
}

.f-r {
  float: right;
}

.s-o {
  background: #f3f3f3;
  border: none;
  font-family: "Open regular";
  font-size: 16px;
  padding: 5px;
  width: 200px;
}

.s-o option {
  padding: 5px;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}
.btn-actions {
  background: transparent;
  border: none;
}

/*
* Error 
*/

.error {
  color: red;
  font-size: 12px;
}

.error ul {
  padding: 0;
  list-style: none;
}
</style>
